/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IWETH9Like, IWETH9LikeInterface } from "../IWETH9Like";

const _abi = [
  {
    inputs: [],
    name: "deposit",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IWETH9Like__factory {
  static readonly abi = _abi;
  static createInterface(): IWETH9LikeInterface {
    return new utils.Interface(_abi) as IWETH9LikeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IWETH9Like {
    return new Contract(address, _abi, signerOrProvider) as IWETH9Like;
  }
}
